import { jsx as _jsx } from "react/jsx-runtime";
import { Drag } from '@otp/icons';
import styles from './index.module.css';
export const sortColumnConfig = {
    name: 'sort',
    options: {
        customHeadLabelRender: () => '',
        customBodyRender: () => _jsx(SortColumn, {}),
    },
};
export const SortColumn = () => {
    return _jsx(Drag, { className: `sortable-handle ${styles.sortColumnIcon}` });
};
